import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { HoverDataAllFields } from '../interfaces';
import { loadHoverData, loadHoverDataSuccess, resetHoverData } from './hover-chart.actions';

const hoverChartState: HoverDataAllFields = {
	id: null,
	CityName: 'No Data',
	CommunityName: 'No Data',
	SectorName: 'No Data',
	PlotName: 'No Data',
	BuildingName: 'No Data',
	FloorName: 'No Data',
	name: 'No Data',
	label: 'No Data',
	TotalFloors: 'No Data',
	TotalNumberOfResidentialUnits: 'No Data',
	TotalNumberOfBuildings: 'No Data',
	TotalNumberOfKeys: 'No Data',
	CompletionStatus: 'No Data',
	AssetType: 'No Data',
	Developer: 'No Data',
	OwnershipType: 'No Data',
	Type: 'No Data',
	UnitName: 'No Data',
	Country: 'UAE',
	_rid: null,
	_self: null,
	_etag: null,
	_attachments: null,
	_ts: null,
	$$errorFromApi: null,
	purpose: null,
};

export const hoverDataFeature = createFeature({
	name: 'hoverData',
	reducer: createReducer(
		hoverChartState,
		on(loadHoverData, (state) => {
			return { ...state };
		}),
		on(loadHoverDataSuccess, (state, { payload }) => {
			return Object.assign({}, state, payload);
		}),
		on(resetHoverData, () => {
			return hoverChartState;
		}),
	),
});

export const selectHoverChartData = createSelector(
	hoverDataFeature.selectHoverDataState,
	(hoverChartData) => hoverChartData,
);

export const { name, reducer, selectHoverDataState } = hoverDataFeature;
